const divModalFilterUser = {
  cancel: 'CANCEL',
  ok: 'APPLY'
};

export default divModalFilterUser;
